// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"8c83fa6b1e699f01f609","883":"62614be028f4560c90c3"}[chunkId] + ".js";
};